import request from './request'
export async function checkPermission(feature, action) {
  var permissionDatas = JSON.parse(localStorage.getItem('permissionDatas'));
  let permissionStatus = false;
  if (permissionDatas?.userType === 'SuperAdmin') {
    return true;
  }
  if (permissionDatas && permissionDatas.role != null) {
    const permissions = permissionDatas.activeBranchData.role.permissions;
    for await (const permission of permissions) {
      if (
        permission.features &&
        permission.features?.name?.toUpperCase().trim() === feature.toUpperCase().trim() &&
        permission.action?.toUpperCase().trim() === action.toUpperCase().trim()
      ) {
        permissionStatus = true;
      }
    }
    return permissionStatus;
  } else {
    return permissionStatus;
  }
}

export const checkRFQEditPermission = (module: string, action: string, userId: number,rfq=null) => {
  return request({
    url: 'user/checkAssignedUserDataAccess',
    method: 'post',
    data: {
      moduleName: module,
      action: action,
      entityCreatedBy: userId,
      rfqId:rfq?.id
    },
  });
};
